/**
 * D6DamageGTConditionType - Condition qui vérifie si les Dégâts sont supérieurs à une valeur
 * Identique à Java DamageGTCondition
 */

import {ConditionType} from '../../types/ConditionType';
import {GameState} from '../../../models/GameState';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class D6DamageGTConditionType implements ConditionType {
  typeName = 'D6_COND_DAMAGE_GT';
  messageKey = 'laventurier.condition.d6.damage-gt.name';
  descriptionKey = 'laventurier.condition.d6.damage-gt.desc';
  errorKey = 'laventurier.condition.d6.damage-gt.error';
  hasValue = true;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any): boolean {
    const threshold = parseInt(condition.value || condition.threshold || '0', 10);
    if (isNaN(threshold)) {
      console.log('[D6DamageGTConditionType] FALSE: invalid threshold value');
      return false;
    }

    const damageField = GameStateHelper.getAdventureExtraField(gameState, 'D6_DAMAGE');
    if (!damageField) {
      console.log('[D6DamageGTConditionType] FALSE: D6_DAMAGE field not found');
      return false;
    }

    const currentDamage = parseInt(String(damageField.currentValue || damageField.initValue || '0'), 10);
    const result = currentDamage > threshold;
    console.log(`[D6DamageGTConditionType] ${result ? 'TRUE' : 'FALSE'}: currentDamage=${currentDamage}, threshold=${threshold}`);
    return result;
  }
}
